import { connect } from 'react-redux'
import { getFormValues, getFormSyncErrors } from 'redux-form'
import EkgRecordingReviewScreen from './EkgRecordingReviewScreen'
import {
  getEkgRecordingReviewScreenData,
  setInitialEkgRecordingReviewScreenData,
  showAddInterpretationScreen,
  cancelAddInterpretations,
  saveAddInterpretations,
  toggleInterpretationHistoryExpanded,
  toggleRecordingInvert,
  handleOnPopoverButtonClick,
  handleOnPopoverOutsideClick,
  handleOnStackControlsCancelDialogClick,
  handleOnStackControlsSuccessDialogClick,
  handleOnExportClick,
  handleOnRequestQT,
  handleQTModalOpen,
  handleQTModalClose,
  handleStackControl,
  handleOnStackNavigationClick,
  updateInterpretations,
  updateInterpretationNotes,
  reset,
  handleOnRefreshClick,
  handleQtFormSubmit,
  // medanta
  updateMedantaInterpretations,
  clearMedantaInterpretations,
} from './module'
import { handleOnPatientClick } from '../../pages/PatientFile/module'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES, FORMS } from '../../constants'
import { EKG_RECORDING_REDUCERS } from 'state/reducers/ekgRecordings/ekgRecordingReducers'
import { withMixpanel } from 'common/mixpanelHelper'

const mapActionCreators = {
  getEkgRecordingReviewScreenData,
  setInitialEkgRecordingReviewScreenData,
  showAddInterpretationScreen,
  cancelAddInterpretations,
  saveAddInterpretations,
  toggleInterpretationHistoryExpanded,
  toggleRecordingInvert,
  handleOnPopoverButtonClick,
  handleOnPopoverOutsideClick,
  handleOnStackControlsCancelDialogClick,
  handleOnStackControlsSuccessDialogClick,
  handleOnExportClick,
  handleOnRequestQT,
  handleQTModalOpen,
  handleQTModalClose,
  handleStackControl,
  handleOnStackNavigationClick,
  updateInterpretations,
  updateInterpretationNotes,
  handleOnPatientClick,
  reset,
  handleOnRefreshClick,
  handleQtFormSubmit,
  // medanta
  updateMedantaInterpretations,
  clearMedantaInterpretations,
}

const mapStateToProps = state => ({
  dataIsFetching: state.ekgRecordingReviewScreen.dataIsFetching,
  dataLastUpdated: state.ekgRecordingReviewScreen.dataLastUpdated,
  refreshClicked: state.ekgRecordingReviewScreen.refreshClicked,
  ecgExporting: state.ekgRecordingReviewScreen.ecgExporting,
  addInterpretationSubmitting: state.ekgRecordingReviewScreen.addInterpretationSubmitting,
  sidebarIsCollapsed: state.app.sidebarIsCollapsed,
  authorizationType: state.auth.authorizationType,
  selectedInterpretations: state.ekgRecordingReviewScreen.selectedInterpretations,
  invertRecording: state.ekgRecordingReviewScreen.invertRecording,
  isAddInterpretationScreenVisible: state.ekgRecordingReviewScreen.isAddInterpretationScreenVisible,
  isInterpretationHistoryExpanded: state.ekgRecordingReviewScreen.isInterpretationHistoryExpanded,
  selectedRecordingId: state.ekgRecordingReviewScreen.selectedRecordingId,
  selectedDropover: state.ekgRecordingReviewScreen.selectedDropover,
  me: getDataSource(state, DATASOURCES.ME),
  patient: getDataSource(state, DATASOURCES.PATIENT),
  patients: getDataSource(state, DATASOURCES.PATIENTS),
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  ekg: getDataSource(state, DATASOURCES.EKG),
  ekgRelated: getDataSource(state, DATASOURCES.EKG_RELATED),
  ekgSamples: getDataSource(state, DATASOURCES.EKG_SAMPLES),
  ekgs: getDataSource(state, DATASOURCES.EKGS),
  interpretations: getDataSource(state, DATASOURCES.INTERPRETATIONS),
  singleEkgPdf: getDataSource(state, DATASOURCES.SINGLE_EKG_PDF),
  vendorInterpretation: getDataSource(state, DATASOURCES.VENDOR_INTERPRETATION),
  [EKG_RECORDING_REDUCERS.EKG_QT]: state.ekgRecordings[EKG_RECORDING_REDUCERS.EKG_QT],
  [EKG_RECORDING_REDUCERS.POST_QT_REQUEST]: state.ekgRecordings[EKG_RECORDING_REDUCERS.POST_QT_REQUEST],
  [EKG_RECORDING_REDUCERS.POST_QT_VALUES]: state.ekgRecordings[EKG_RECORDING_REDUCERS.POST_QT_VALUES],
  qtFormData: getFormValues(FORMS.QT_VALUES_FORM)(state),
  qtFormValidationSyncError: getFormSyncErrors(FORMS.QT_VALUES_FORM)(state),
  // medanta
  selectedMedantaInterpretations: state.ekgRecordingReviewScreen.selectedMedantaInterpretations,
  medantaInterpretationForm: getFormValues(FORMS.MEDANTA_INTERPRETATION_FORM)(state),
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(withMixpanel(EkgRecordingReviewScreen))



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/container.js